import { Component, inject } from '@angular/core';
import { TruckLogicService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TruckLogicCreateDto,
  TruckLogicDto,
  TruckLogicExcelDownloadDto,
  TruckLogicUpdateDto,
} from '../proxy/general/dtos/truck-logic';
import { TRUCKLOGIC_CONFIG, TRUCKLOGIC_FIELDS } from './truck-logic.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-truck-logic',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TruckLogicService, ConfirmationService],
  templateUrl: './truck-logic.html',
  styleUrl: './truck-logic.scss',
})
export class TruckLogic extends BaseCrudComponent<
  TruckLogicDto,
  TruckLogicCreateDto,
  TruckLogicUpdateDto,
  TruckLogicExcelDownloadDto
> {
  service = inject(TruckLogicService);
  config = TRUCKLOGIC_CONFIG;
  fields = TRUCKLOGIC_FIELDS;

  protected prepareUpdateDto(data: any, selected: TruckLogicDto): TruckLogicUpdateDto {
    return {
      name: data.name,
      fromQuantity: data.fromQuantity,
      untilQuantity: data.untilQuantity,
      unitOfMeasureId: data.unitOfMeasureId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TruckLogic';
  }
}
